<template>
  <div :class="['article-card', fluid && 'article-card-fluid']" v-ripple>
    <router-link v-if="img && !invalidImage" :to="to">
      <img
        :src="files + img + '?resize=1&w=270'"
        :alt="title"
        :title="title"
        loading="lazy"
        @error="invalidImage = true"
      />
    </router-link>
    <div class="mt-2">
      <v-btn
        :to="categoryTo"
        class="rounded-pill font-weight-bold px-5 text-caption"
        color="secondary"
        small
        depressed
      >
        {{ categoryText }}
      </v-btn>
    </div>
    <div class="text-body-2 font-weight-bold article-card-title mt-2">
      <router-link
        :to="to"
        v-html="title"
        class="text-decoration-none grey--text text--darken-4"
      ></router-link>
    </div>
  </div>
</template>

<script>
import { formatToURL } from "@/components/utils.js";

export default {
  props: {
    id: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    categoryTitle: {
      type: String,
    },
    img: {
      type: String,
    },
    type: {
      type: String,
      default: "news",
    },
    fluid: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    invalidImage: false,
  }),
  computed: {
    categoryText() {
      let text;
      switch (this.type) {
        case "opinion":
          text = "Opinião";
          break;
        case "chronicle":
          text = "Crônica";
          break;
        case "news":
          text = this.categoryTitle;
          break;
      }

      return text;
    },
    categoryTo() {
      let path;

      switch (this.type) {
        case "opinion":
          path = "/opiniao";
          break;
        case "chronicle":
          path = "/cronica";
          break;
        case "news":
          path = `/noticias/${formatToURL(this.categoryTitle)}`;
          break;
      }

      return path;
    },
    to() {
      return `${this.categoryTo}/${formatToURL(this.title)}-${this.id}`;
    },
  },
};
</script>

<style>
.article-card {
  position: relative;
  max-width: 270px;
}

.article-card-fluid {
  max-width: initial;
}

.article-card img {
  aspect-ratio: 270 / 179;
  object-fit: cover;
  width: 100%;
}

.article-card img,
.article-card-title,
.article-card-category {
  transition: all 0.1s linear;
}

@media screen and (max-width: 1264px) {
  .article-card-title {
    font-size: 14px;
  }
}

.article-card:hover img {
  opacity: 0.8;
}

.article-card:hover .article-card-title a {
  color: var(--v-primary-darken2) !important;
}

.article-card-title {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
